import React from 'react';
import { Form } from 'informed';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { debounce } from 'lodash'
import { API_HOST } from '../../consts';
import { default as FormContainer } from '../../containers/Form';
import InputText from '../../components/inputs/InputText';
import InputSpan from '../../components/inputs/InputSpan';
import Loading from '../../components/Loading';
import InputSelect from '../../components/inputs/InputSelect';
import InputNumber from '../../components/inputs/InputNumber';
import InputCurrency from '../../components/inputs/InputCurrency';
import BaseForm from '../../base/BaseForm';

const mapAreaConhecimento = (x) => ({
  value: x.id,
  label: x.descricao
});

const mapInstituicao = (x) => ({
  value: x.id,
  label: x.descricao
});

class Dados extends BaseForm {
  constructor(props) {
    super(props);
    this.id = props.match.params.id;
    this.fields = [
      'nome',
      'inicio_realizacao_exame',
      'termino_realizacao_exame',
      'inicio_recebimento_item',
      'termino_recebimento_item',
      'inicio_validacao_pedagogica',
      'termino_validacao_pedagogica',
      'total_itens_encomenda',
      'total_itens_exame',
      'minimo_itens',
      'valor_elaboracao',
      'total_alternativas',
      'instituicao',
      'periodo',
      'curso'
    ];
    this.multiFields = ['areas_conhecimento'];
  }

  state = {
    areas_conhecimento: [],
    instituicoes: [],
    submitting: false,
    fetchingData: true,
    cusoId: ''
  };

  componentDidMount() {
    this.fetchData();
    this.fetchAreasConhecimento();
    this.fetchInstituicoes();
    this.fetchPeriodo();
    this.fetchCurso();
  }

  fetchAreasConhecimento() {
    axios.get(`${API_HOST}/core/area_conhecimento`).then((response) => {
      this.setState({
        areas_conhecimento: response.data.map(mapAreaConhecimento)
      });
    });
  }

  fetchCurso = (e) => {
    this.setState({ isLoading: true });
    axios.get(`${API_HOST}/core/curso`).then((response) => {
      this.setState({
        isLoading: false,
        curso: response.data.map((x) => ({
          value: x.id,
          label: x.descricao
        }))
      });
    });
  };


  fetchPeriodo = debounce((input, callback) => {
    const { cursoId } = this.state;

    if (cursoId) {
      axios
        .get(`${API_HOST}/core/periodo/${cursoId}/filter_curso`)
        .then((response) => {
          const options = []
          response.data.map((mapResponse) => {
            if (mapResponse.etapa_nr && mapResponse.oculto !== true) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao,
              })
            }
          })
          this.setState({ periodo: options })
          callback(null, { options })

        })
        .catch((error) => console.log(error))
    }
    else {
      axios
        .get(`${API_HOST}/core/periodo`)
        .then((response) => {
          const options = []
          response.data.map((mapResponse) => {
            if (mapResponse.etapa_nr) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao,
              })
            }
          })
          this.setState({ periodo: options })
          callback(null, { options })
        })
        .catch((error) => console.log(error))
    }
  }, 1000);

  fetchInstituicoes() {
    axios.get(`${API_HOST}/core/instituicao`).then((response) => {
      this.setState({ instituicoes: response.data.map(mapInstituicao) });
    });
  }

  fetchData() {
    if (this.id !== 'new') {
      axios
        .get(`${API_HOST}/encomenda/encomenda/${this.id}/form`)
        .then((response) => {
          const { data } = response;
          let { valor_elaboracao } = data;
          if (valor_elaboracao) {
            valor_elaboracao = valor_elaboracao.replace('.', ',');
          }
          this.setFields({ ...data, valor_elaboracao });
          this.setState({ fetchingData: false });
        });
    } else {
      this.setState({ fetchingData: false });
    }
  }

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    Object.keys(values).forEach((x) => {
      if (values[x] === '') {
        values[x] = null;
      }
    });

    if (values.valor_elaboracao) {
      values.valor_elaboracao = values.valor_elaboracao
        .replace('R$ ', '')
        .replace(',', '.');
    }

    if (this.id === 'new') {
      axios
        .post(`${API_HOST}/encomenda/encomenda`, values)
        .then((response) => {
          const { history } = this.props;
          this.id = response.data.id;
          history.push(`/encomendas/${response.data.id}/matrizes-referencia`);
        })
        .catch(this.onValidateError);
    } else {
      axios
        .patch(`${API_HOST}/encomenda/encomenda/${this.id}`, values)
        .then(() => {
          const { history } = this.props;
          history.push(`/encomendas/${this.id}/matrizes-referencia`);
        })
        .catch(this.onValidateError);
    }
  };

  onValidateError = (error) => {
    this.setState({ submitting: false });
    super.onValidateError(error);
  };

  handleNext = (next) => {
    this.next = next;
    this.formApi.submitForm();
  };

  render() {
    const {
      areas_conhecimento,
      submitting,
      fetchingData,
      instituicoes,
      periodo,
      curso
    } = this.state;

    return (
      <Form
        onChange={(formState) => this.setState({ formState })}
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
        onSubmit={this.handleSubmit}
      >
        {() => {
          if (fetchingData) {
            return <Loading />;
          }

          return (
            <FormContainer
              next
              title="Dados gerais"
              onClick={() => this.formApi.submitForm()}
              disabled={submitting}
            >
              <div className="row">
                <InputText col="col-sm-12" label="Nome" field="nome" />
              </div>
              <div className="row">
                <InputSelect
                  col="col-sm-12"
                  label="Instituição"
                  options={instituicoes}
                  field="instituicao"
                />
              </div>
              <div className="row">
                <InputSelect
                  multi
                  col="col-sm-12"
                  label="Áreas de conhecimento"
                  options={areas_conhecimento}
                  field="areas_conhecimento"
                />
              </div>
              <div className="row">
                <InputSelect
                  col="col-sm-12"
                  label="Segmento/Etapa"
                  field="curso"
                  options={curso}
                  onChange={
                    (event) => event ? (
                      this.setState({ codigoId: event.codigo, cursoId: event.value }),
                      this.fetchPeriodo()
                    ) : (
                      this.setState({ codigoId: "", cursoId: "" }),
                      this.fetchPeriodo()
                    )
                  }
                />
              </div>
              <div className="row">
                <InputSelect
                  col="col-sm-12"
                  label="Série/Ano"
                  options={periodo}
                  field="periodo"
                />
              </div>
              <hr />
              <div className="row">
                <InputSpan
                  col="col-sm-5"
                  label="Período de realização"
                  leftAddon="início"
                  field="inicio_realizacao_exame"
                  type="date"
                />
                <InputSpan
                  col="col-sm-5"
                  leftAddon="término"
                  field="termino_realizacao_exame"
                  type="date"
                />
              </div>
              <div className="row">
                <InputSpan
                  col="col-sm-5"
                  label="Período de recebimento dos objetos de aprendizagem"
                  leftAddon="início"
                  field="inicio_recebimento_item"
                  type="date"
                />
                <InputSpan
                  col="col-sm-5"
                  leftAddon="término"
                  field="termino_recebimento_item"
                  type="date"
                />
              </div>
              <div className="row">
                <InputSpan
                  col="col-sm-5"
                  label="Período de validação pedagógica "
                  leftAddon="início"
                  field="inicio_validacao_pedagogica"
                  type="date"
                />
                <InputSpan
                  col="col-sm-5"
                  leftAddon="término"
                  field="termino_validacao_pedagogica"
                  type="date"
                />
              </div>
              <hr />
              <div className="row">
                <InputNumber
                  col="col-sm-4"
                  label="Total de objetos de aprendizagem da encomenda"
                  field="total_itens_encomenda"
                />
                <InputNumber
                  col="col-sm-4"
                  label="Total de objetos de aprendizagem da atividade"
                  field="total_itens_exame"
                />
                <InputNumber
                  col="col-sm-4"
                  label="Mínimo de objetos de aprendizagem para considerar a encomenda concluída"
                  field="minimo_itens"
                />
                <InputCurrency
                  col="col-sm-4"
                  label="Valor de elaboração do objeto de aprendizagem"
                  field="valor_elaboracao"
                />
                <InputNumber
                  col="col-sm-4"
                  label="Quantidade de alternativas do objeto de aprendizagem"
                  field="total_alternativas"
                  mask_="9"
                />
              </div>
            </FormContainer>
          );
        }}
      </Form>
    );
  }
}

export default withRouter(Dados);
